/* Titan Wash — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  // Cache scroll-related elements once
  var progressBar   = document.getElementById('scrollProgress');
  var navbar        = document.querySelector('.navbar');
  var parallaxImgs  = document.querySelectorAll('.photo-hero .hero-bg-img');

  // Unified rAF-throttled scroll handler
  var scrollTicking = false;

  function handleScrollFrame() {
    var scrollY   = window.scrollY;
    var docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    if (progressBar) {
      var progress = docHeight > 0 ? scrollY / docHeight : 0;
      progressBar.style.transform = 'scaleX(' + progress + ')';
    }

    if (navbar) {
      if (scrollY > 50) { navbar.classList.add('scrolled'); }
      else              { navbar.classList.remove('scrolled'); }
    }

    for (var i = 0; i < parallaxImgs.length; i++) {
      var rect = parallaxImgs[i].parentElement.getBoundingClientRect();
      parallaxImgs[i].style.transform = 'translateY(' + (rect.top * 0.3) + 'px) scale(1.1)';
    }

    scrollTicking = false;
  }

  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      requestAnimationFrame(handleScrollFrame);
      scrollTicking = true;
    }
  }, { passive: true });

  // Mobile Nav Toggle
  var navToggle = document.querySelector('.nav-toggle');
  var navLinks  = document.querySelector('.nav-links');
  if (navToggle && navLinks) {
    navToggle.addEventListener('click', function () {
      navLinks.classList.toggle('open');
    });
    navLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        navLinks.classList.remove('open');
      });
    });
  }

  // Intersection Observer (fade, slide, scale)
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.fade-in, .slide-left, .slide-right, .scale-in').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.fade-in, .slide-left, .slide-right, .scale-in').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  // 3D Tilt on Cards
  document.querySelectorAll('.sport-card, .stat-box, .step-card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect    = card.getBoundingClientRect();
      var x       = e.clientX - rect.left;
      var y       = e.clientY - rect.top;
      var rotateX = (y - rect.height / 2) / 20;
      var rotateY = (rect.width / 2 - x) / 20;
      card.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-8px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });

  // Counter Animation for Stat Bar
  if ('IntersectionObserver' in window) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var h3 = entry.target.querySelector('h3');
          if (h3 && !h3.dataset.animated) {
            h3.dataset.animated = 'true';
            var target   = parseInt(h3.dataset.count || h3.textContent);
            var suffix   = h3.dataset.suffix !== undefined ? h3.dataset.suffix : h3.textContent.replace(/[0-9]/g, '');
            var current  = 0;
            var duration = 1200;
            var step     = target / (duration / 16);
            var timer    = setInterval(function () {
              current = Math.min(current + step, target);
              h3.textContent = Math.round(current) + suffix;
              if (current >= target) clearInterval(timer);
            }, 16);
          }
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.stat-box').forEach(function (box) {
      counterObserver.observe(box);
    });
  }

  // Shop Page Logic
  initShopPage();
});


function initShopPage() {

  // Pricing data
  var PRICES = {
    onetime: { 1: 14.99, 2: 26.99, 3: 36.99 },
    sub4:    { 1: 12.74, 2: 22.94, 3: 31.44 },
    sub8:    { 1: 12.74, 2: 22.94, 3: 31.44 }
  };
  var FULL    = { 1: 14.99, 2: 29.98, 3: 44.97 };
  var COMPARE = { onetime: { 1: null, 2: 29.98, 3: 44.97 } };
  var WASHES  = { 1: 25, 2: 50, 3: 75 };

  var VARIANT_IDS = {
    1: '55788594889086',
    2: '57762233680254',
    3: '57762233713022'
  };
  var SELLING_PLANS = {
    '4': '711587594622',
    '8': '711587627390'
  };
  var SHOP_URL = 'https://titanwash.co.uk';

  var type = 'subscribe';
  var qty  = 2;

  // Guard — only run on the shop page
  if (!document.getElementById('buyBtn') && !document.querySelector('.bundle-card')) return;

  // Helpers
  function getFreq() {
    var el = document.querySelector('input[name="freq"]:checked');
    return el ? el.value : '4';
  }

  function getPriceKey() {
    return type === 'subscribe' ? 'sub' + getFreq() : 'onetime';
  }

  function refreshAll() {
    updateBundlePrices();
    updatePriceBuy();
    updateShipBar();
  }

  // Bundle prices & compare
  function updateBundlePrices() {
    var priceKey      = getPriceKey();
    var freq          = getFreq();
    var discountLabel = '15%';

    var headline = document.getElementById('subHeadline');
    if (headline) headline.textContent = '\u26a1 YOUR SUBSCRIPTION \u2014 ' + discountLabel + ' OFF EVERY ORDER';

    [1, 2, 3].forEach(function (q) {
      var price      = PRICES[priceKey][q];
      var compareVal = type === 'subscribe' ? FULL[q] : COMPARE.onetime[q];

      var priceEl   = document.getElementById('p' + q);
      var compareEl = document.getElementById('c' + q);
      var saveEl    = document.getElementById('s' + q);

      if (priceEl)   priceEl.textContent = '\u00a3' + price.toFixed(2);

      if (compareEl) {
        if (compareVal) {
          compareEl.textContent   = '\u00a3' + compareVal.toFixed(2);
          compareEl.style.display = 'block';
        } else {
          compareEl.textContent   = '';
          compareEl.style.display = 'none';
        }
      }

      if (saveEl) {
        if (type === 'subscribe') {
          var saved = ((compareVal || FULL[q]) - price).toFixed(2);
          saveEl.textContent    = 'Save \u00a3' + saved;
          saveEl.style.display  = 'inline-block';
        } else {
          var staticSaves = { 1: null, 2: 'Save \u00a33', 3: 'Save \u00a38' };
          if (staticSaves[q]) {
            saveEl.textContent    = staticSaves[q];
            saveEl.style.display  = 'inline-block';
          } else {
            saveEl.style.display  = 'none';
          }
        }
      }
    });
  }

  // Price display & buy URL
  function updatePriceBuy() {
    var priceKey = getPriceKey();
    var price    = PRICES[priceKey][qty];
    var washes   = WASHES[qty];
    var perWash  = (price / washes * 100).toFixed(0);
    var shipNote = qty >= 2 ? '\u00b7 <strong>Free shipping</strong>' : '\u00b7 Standard shipping';

    var dynPrice = document.getElementById('dynPrice');
    var dynMeta  = document.getElementById('dynMeta');
    var stickyP  = document.getElementById('stickyPrice');
    if (dynPrice) dynPrice.textContent = '\u00a3' + price.toFixed(2);
    if (dynMeta)  dynMeta.innerHTML    = perWash + 'p per wash ' + shipNote;
    if (stickyP)  stickyP.textContent  = '\u00a3' + price.toFixed(2);

    var variantId  = VARIANT_IDS[qty];
    var sellingPlan = (type === 'subscribe') ? SELLING_PLANS[getFreq()] : null;
    var buyBtn = document.getElementById('buyBtn');
    if (buyBtn) { buyBtn.dataset.variantId = variantId; buyBtn.dataset.sellingPlan = sellingPlan || ''; }
    var stickyBuyBtn = document.querySelector('.sticky-bar .btn-buy-big');
    if (stickyBuyBtn) { stickyBuyBtn.dataset.variantId = variantId; stickyBuyBtn.dataset.sellingPlan = sellingPlan || ''; }
  }

  // AJAX Add to Cart
  window.titanAddToCart = function() {
    var btn = document.getElementById('buyBtn');
    var variantId   = parseInt((btn && btn.dataset.variantId) || VARIANT_IDS[qty], 10);
    var sellingPlan = (btn && btn.dataset.sellingPlan) || '';
    var body = { id: variantId, quantity: 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;

    var btns = document.querySelectorAll('#buyBtn, .sticky-bar .btn-buy-big');

    if (window.Shopify && window.Shopify.designMode) {
      btns.forEach(function(b) { b.textContent = '\u2713 Added to Cart'; });
      setTimeout(function() {
        btns.forEach(function(b) {
          b.disabled = false;
          b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 001.96-1.57L23 6H6"/></svg> Add to Cart';
        });
      }, 2000);
      return;
    }

    btns.forEach(function(b) { b.disabled = true; b.textContent = 'Adding\u2026'; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function(r) {
      if (!r.ok) throw new Error('cart_error');
      return r.json();
    })
    .then(function() {
      window.location.href = '/cart';
    })
    .catch(function() {
      window.location.href = '/cart/' + variantId + ':1' + (sellingPlan ? '?selling_plan=' + sellingPlan : '');
    });
  };

  // Free Sample
  var SAMPLE_VARIANT_ID = 57565811114366;
  var sampleBtn     = document.getElementById('sampleBtn');
  var sampleBtnText = document.getElementById('sampleBtnText');
  var sampleNote    = document.getElementById('sampleNote');

  function updateCartState() {
    var alreadyClaimed = sampleBtn && sampleBtn.dataset.alreadyClaimed === 'true';
    var claimedLocally  = false;
    try { claimedLocally = localStorage.getItem('titanSampleClaimed') === 'true'; } catch (e) {}

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasSample     = cart.items.some(function(i) { return i.variant_id === SAMPLE_VARIANT_ID; });
        var hasOtherItems = cart.items.some(function(i) { return i.variant_id !== SAMPLE_VARIANT_ID; });

        if (sampleBtn) {
          if (hasSample) {
            sampleBtn.disabled = true;
            if (sampleBtnText) sampleBtnText.textContent = '\u2713 Sample Added';
            if (sampleNote)    sampleNote.textContent    = 'Your sample is in your cart \u2014 head to checkout.';
          } else if (alreadyClaimed || claimedLocally) {
            sampleBtn.disabled = true;
            if (sampleBtnText) sampleBtnText.textContent = 'Already Claimed';
            if (sampleNote)    sampleNote.textContent    = "You've already claimed your sample.";
          } else if (hasOtherItems) {
            sampleBtn.disabled = true;
            if (sampleBtnText) sampleBtnText.textContent = 'Not eligible with other purchases';
            if (sampleNote)    sampleNote.textContent    = 'Remove other items from your cart to claim a sample.';
          } else {
            sampleBtn.disabled = false;
            if (sampleBtnText) sampleBtnText.textContent = 'Try a Sample';
            if (sampleNote)    sampleNote.textContent    = 'One per customer \u00b7 Cannot be combined with other purchases';
          }
        }

        document.querySelectorAll('#buyBtn, .sticky-bar .btn-buy-big').forEach(function(b) {
          b.dataset.sampleInCart = hasSample ? 'true' : '';
        });
      });
  }

  var _origAddToCart = window.titanAddToCart;
  window.titanAddToCart = function() {
    var btns = document.querySelectorAll('#buyBtn, .sticky-bar .btn-buy-big');
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasSample = cart.items.some(function(i) { return i.variant_id === SAMPLE_VARIANT_ID; });
        if (hasSample) {
          btns.forEach(function(b) { b._origHTML = b.innerHTML; b.disabled = true; b.textContent = 'Remove sample first'; });
          setTimeout(function() {
            btns.forEach(function(b) { b.disabled = false; b.innerHTML = b._origHTML || 'Add to Cart'; });
          }, 2500);
          return;
        }
        _origAddToCart();
      })
      .catch(function() { _origAddToCart(); });
  };

  window.titanAddSample = function() {
    if (sampleBtn && sampleBtn.disabled) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasOtherItems = cart.items.some(function(i) { return i.variant_id !== SAMPLE_VARIANT_ID; });
        var hasSample = cart.items.some(function(i) { return i.variant_id === SAMPLE_VARIANT_ID; });
        var claimedLocally = false;
        try { claimedLocally = localStorage.getItem('titanSampleClaimed') === 'true'; } catch (e) {}
        if (hasOtherItems || hasSample || claimedLocally) {
          updateCartState();
          return;
        }
        if (sampleBtnText) sampleBtnText.textContent = 'Adding\u2026';
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: SAMPLE_VARIANT_ID, quantity: 1 })
        })
        .then(function() {
          try { localStorage.setItem('titanSampleClaimed', 'true'); } catch (e) {}
          window.location.href = '/cart';
        });
      })
      .catch(function() { window.location.href = '/cart/' + SAMPLE_VARIANT_ID + ':1'; });
  };

  updateCartState();

  // Ship bar
  function updateShipBar() {
    var msg  = document.getElementById('shipMsg');
    var fill = document.getElementById('shipFill');
    var bar  = document.getElementById('shipBar');
    if (!msg || !fill) return;
    if (qty === 1) {
      msg.innerHTML = 'Add <strong>1 more pouch</strong> to unlock FREE shipping \ud83c\udf81';
      fill.style.width = '40%';
      if (bar) bar.classList.remove('unlocked');
    } else if (qty === 2) {
      msg.innerHTML = '\ud83c\udf89 <strong>FREE SHIPPING</strong> unlocked! Add 1 more for the best value bundle.';
      fill.style.width = '75%';
      if (bar) bar.classList.add('unlocked');
    } else {
      msg.innerHTML = '\ud83c\udfc6 <strong>FREE SHIPPING</strong> + Best value bundle selected!';
      fill.style.width = '100%';
      if (bar) bar.classList.add('unlocked');
    }
  }

  // Purchase type toggle
  window.setType = function (t) {
    type = t;
    var btnO   = document.getElementById('btnOnetime');
    var btnS   = document.getElementById('btnSubscribe');
    var subBox = document.getElementById('subBox');
    if (btnO)   btnO.classList.toggle('active', t === 'onetime');
    if (btnS)   btnS.classList.toggle('active', t === 'subscribe');
    if (subBox) subBox.style.display = t === 'subscribe' ? 'block' : 'none';
    refreshAll();
  };

  // Bundle select
  window.selectBundle = function (card) {
    document.querySelectorAll('.bundle-card').forEach(function (c) { c.classList.remove('selected'); });
    card.classList.add('selected');
    qty = parseInt(card.dataset.qty);
    refreshAll();
  };

  // Frequency change
  window.refreshAll = function () { refreshAll(); };

  // Image switcher
  window.switchImg = function (thumb, src) {
    var mainImg = document.getElementById('mainImg');
    if (mainImg) mainImg.src = src;
    document.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  };

  // Dispatch countdown
  function updateCountdown() {
    var el = document.getElementById('countdown');
    if (!el) return;
    var now    = new Date();
    var cutoff = new Date();
    cutoff.setHours(15, 0, 0, 0);
    if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var diff = cutoff - now;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    el.textContent =
      String(h).padStart(2,'0') + ':' +
      String(m).padStart(2,'0') + ':' +
      String(s).padStart(2,'0');
  }
  updateCountdown();
  setInterval(updateCountdown, 1000);

  // Sticky bar show/hide
  var stickyBar  = document.getElementById('stickyBar');
  var shopHeroEl = document.querySelector('.shop-hero');
  if (stickyBar && shopHeroEl) {
    var heroBottom = shopHeroEl.offsetTop + shopHeroEl.offsetHeight;
    window.addEventListener('scroll', function () {
      stickyBar.style.display = window.scrollY > heroBottom ? 'block' : 'none';
    }, { passive: true });
  }

  // Init
  refreshAll();
}
